module.exports = "https://la-static.vkplay.ru/promo/newstart/img/wildsoul.3ff2c323.png";